import PropTypes from 'prop-types'

import Icon from '../Icons'

const SuccessConfirmationModal = ({ header, description, handleClose }) => {
  return (
    <div className="success-confirmation-modal">
      <div className="success-confirmation-modal__container">
        <Icon
          icon="checkmark"
          viewBox="0 0 30 30"
          styles={{
            borderRadius: '100%',
            padding: '4px',
            fill: '#548671',
            height: '30px',
            width: '30px',
            outline: '2px solid #548671',
          }}
        />
        <h1>{header}</h1>
        <div className="description-body">{description}</div>
        <button className="button button-gray" onClick={handleClose}>
          Close
        </button>
      </div>
    </div>
  )
}

SuccessConfirmationModal.propTypes = {
  header: PropTypes.string,
  description: PropTypes.node,
  handleClose: PropTypes.func,
}

export default SuccessConfirmationModal
